import * as React from 'react'

import {
  Box,
  InputCheckBox as CheckBox,
  type Colors,
  Icon,
  type SmallIcon,
  Text,
} from '@factorialco/deprecated-design-system'

export interface PublicProps {
  value: string
  label: string
  searchValue: string
  children: React.ReactNode | string
  isDisabled?: boolean
  isHidden?: boolean
  isMultiSelect?: boolean
  showSeparator?: boolean
  isChecked?: boolean
  icon?: SmallIcon
  tooltip?: {
    title?: string
    description: string
  } | null
}

export interface PrivateProps extends PublicProps {
  onChange?: () => void
  isHeader: boolean
}

const OptionComponent: React.FC<PublicProps> = (props) => {
  return (
    <InternalOption
      {...props} // Default empty function - Container will override this
      isHeader={false} // Default to false - Container may override for header options
    />
  )
}
export const InternalOption: React.FC<PrivateProps> = ({
  children,
  onChange,
  isHeader,
  isChecked = false,
  isDisabled = false,
  isHidden = false,
  showSeparator = true,
  isMultiSelect,
  label,
}) => {
  const [isHover, setIsHover] = React.useState<boolean>(false)

  if (isHidden) return null

  const getBgColor = (): Colors => {
    if (isChecked) return isHover ? 'viridian200' : 'viridian100'
    if (isHeader || isDisabled) return 'grey200'
    if (isHover) return 'grey100'

    return 'grey000White'
  }

  const color = !isMultiSelect && isChecked ? 'viridian1200' : 'grey800'

  const handleChange = () => {
    onChange?.()
  }
  return (
    <Box
      onClick={isDisabled ? null : handleChange}
      alignItems="center"
      background={getBgColor()}
      cursor={isDisabled ? 'default' : 'pointer'}
      flexDirection="row"
      gap="s16"
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      paddingX="s16"
      paddingY="s12"
      width="full"
      border={
        showSeparator && {
          top: {
            color: 'grey400',
            width: 's1',
            style: 'solid',
          },
        }
      }
    >
      {isMultiSelect && (
        <CheckBox checked={isChecked} onClick={handleChange} disabled={isDisabled} label={label} />
      )}
      {typeof children === 'string' ? (
        <Text.Normal size="200" weight="medium" color={color}>
          <Box gap="s6" alignItems="center" flexDirection="row">
            {isChecked && !isMultiSelect && isHover && (
              <Icon.Small color="viridian1200" icon="close" />
            )}{' '}
            {children}
          </Box>
        </Text.Normal>
      ) : (
        children
      )}
    </Box>
  )
}

export default OptionComponent
